// extracted by mini-css-extract-plugin
export default {"root":"search_root__fhmK8","icon":"search_icon__FM8lh","input":"search_input__vs5pb"};